import { atom } from "recoil";

export const currentRouteState = atom<IRoute | null>({
  key: 'CurrentRouteState',
  default: null
});
